import Toggle from "../util/toggle";
import Flickity from "flickity";

require("flickity/dist/flickity.css");

export default {
    init() {
    },
    finalize() {
        var toggle = new Toggle('.myaccount__nav-select', '.myaccount__nav-options', 'clicked', 'open');
        var close_toggle = new Toggle('.myaccount__nav-close', '.myaccount__nav-options', null, 'open');
        var login_form_wrapper = document.getElementById('customer_login');

        var scores = document.querySelectorAll('.radial-container');
        if (scores !== null) {
            for (var i = 0; i < scores.length; i++) {
                var percent = scores[i].dataset.progressFinish;
                scores[i].dataset.progress = percent;
            }
        }

        if (document.querySelector('.results-testimonials-carousel') !== null) {

            new Flickity(".results-testimonials-carousel", {
                cellAlign: "left",
                wrapAround: true,
                autoPlay: 3000,
                selectedAttraction: 0.1,
                friction: 1,
                prevNextButtons: true,
                pageDots: false
            });

        }

        jQuery('.myaccount__login-header li').click(function() {
            var $this = jQuery(this);

            if (!$this.hasClass('active')) {
                $this.siblings().removeClass('active');
                $this.addClass('active');

                if (login_form_wrapper) {
                    if (login_form_wrapper.classList.contains('show-register')) {
                        console.log('remove show-register');
                        login_form_wrapper.classList.remove('show-register');
                    }
                    else {
                        console.log('add show-register');
                        login_form_wrapper.classList.add('show-register');
                    }
                }
            }
        });

        jQuery('body').on('click', 'a[href*="#"].scroll-to-link', function(event){
            const href = jQuery(this).attr('href');
            const hash = href.substring(href.indexOf('#'));

            if ( jQuery(hash).length === 0 ) {
                return;
            }

            event.preventDefault();

            jQuery('html, body').animate({
                scrollTop: jQuery(hash).offset().top - 50
            }, 500);
        });        

        jQuery('#reg_password').after("<span id='password_strength' class='woocommerce-password-strength'></span>");

        jQuery("#reg_password").keyup(function(e){

            window.checkPasswordStrength(jQuery(this),jQuery('#password_strength'), [], jQuery('form.register button'), true );

        });

        // report add to cart ajax
        jQuery('body').on('click', '.report_add_to_cart_button', function(e){
            e.preventDefault();

            let loading_consultation_event = new CustomEvent("ew-loading-consultation");
            document.dispatchEvent(loading_consultation_event);

            jQuery.ajax({
                type: "POST",
                url: window.addUrl,
                data: { consultation_products: window.consultation_products, consultation_id: window.consultation_id }
            })
            .done(function () {
                window.location = window.checkoutUrl;
            });
        });        

    }
};



// WEBPACK FOOTER //
// ./js/routes/woocommerce-account.js